import { connect } from 'react-redux';
import { bindActionCreators, Dispatch, Action } from 'redux';

import { StateType } from 'types';
import { selectUserType } from 'redux/selectors/auth';
import { deleteDraftRequest, sendRequest } from 'redux/actions/request';

const mapStateToProps = (state: StateType) => ({
  userType: selectUserType(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators({ deleteDraftRequest, sendRequest }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
